import { render, staticRenderFns } from "./ClientEmailTemplate.vue?vue&type=template&id=294ab928&"
import script from "./ClientEmailTemplate.vue?vue&type=script&lang=ts&"
export * from "./ClientEmailTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ClientEmailTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports